export function getView(treatment_plan) {
  return (
    !treatment_plan.is_treatment_plan_applied ||
    !treatment_plan.is_contract_applied
  )
}
